import { createClient } from '@sanity/client'

export const sanityClient = createClient({
  projectId: '03c4zc36',
  dataset: 'prod',
  apiVersion: '2023-01-01', // match your content version date
  useCdn: false,
})